import { Log, UserManager, WebStorageStateStore } from 'oidc-client-ts';

import { appConfig } from '~/common/config';
import { RouteId } from '~/routes';

if (appConfig.oidc.debug) {
  Log.setLogger(console);
  Log.setLevel(Log.DEBUG);
} else {
  Log.reset();
}

export const authority = `${appConfig.keycloak.url}/realms/${appConfig.keycloak.realm}`;

export const userManager = new UserManager({
  authority,
  client_id: appConfig.keycloak.clientId,
  redirect_uri: `${window.location.origin}${RouteId.authCallback}`,
  silent_redirect_uri: `${window.location.origin}${RouteId.authCallback}`,
  post_logout_redirect_uri: `${window.location.origin}${RouteId.login}`,
  response_mode: 'fragment',
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  popup_redirect_uri: `${window.location.origin}${RouteId.popupCallback}`,
  fetchRequestCredentials: 'include',
});

export const teamsConfig = {
  client_id: appConfig.keycloak.clientId,
  redirect_uri: `${window.location.origin}${RouteId.loginTeamsEnd}`,
  response_type: 'id_token token',
  scope: 'openid profile email',
  response_mode: 'fragment',
};

// if the network connection is interrupted (might be the case when the computer is in sleep mode)
// when the silent renew is triggered, a SilentRenewError is thrown by the lib,
// but the current accessToken doesn't get removed from the localStorage/ram
// -> removing the user manually to force a new login
const removeUser = () => {
  userManager.removeUser();
};
userManager.events.addSilentRenewError(removeUser);
userManager.events.addAccessTokenExpired(removeUser);
